/**
 * FIREBASE'S OWN BROWSER DATABASES, BY NAME (2026-10-31, the sign-in stalls).
 *
 * The names alone, in a leaf with no imports, so the first download can say which database its sign-in boot opens
 * (src/utils/firebase.ts, ./authStartupWatch.ts) without carrying the code that opens, clears or probes one
 * (./firebaseDatabases.ts, which re-exports these and is fetched only when that code is needed).
 */

/** The auth database: if THIS one survives with a user in it, the next sign-in takes the legacy link branch. */
export const AUTH_DB_NAME = 'firebaseLocalStorageDb';

/** The heartbeat's database, read for the header every Firebase request carries. */
export const HEARTBEAT_DB_NAME = 'firebase-heartbeat-database';
